module.exports = __webpack_public_path__ + "img/465.61f23922.png";